import { db } from '../services/firebase';
import moment from 'moment';
import { settingStore } from './settings';

export const invoiceStore = {

	state: {
		invoices: []
	},

	init() {
		return new Promise((resolve, reject) => {
			db.collection('invoices')
				.orderBy('number', 'desc')
				.onSnapshot((data) => {
					this.state.invoices = data.docs.map((doc) => {
						return Object.assign({}, doc.data(), { id: doc.id });
					});

					resolve();
				}, (error) => {
					reject(error);
				});
		});
	},

	destroy() {
		db.collection('invoices').onSnapshot(() => {})();
	},

	get(id) {
		return this.state.invoices.find(i => i.id === id);
	},

	save(invoice) {
		return db.collection('invoices').add(invoice);
	},

	update(id, data) {
		return db.collection('invoices').doc(id).update(data);
	},

	delete(id) {
		return db.collection('invoices').doc(id).delete();
	},

	createEmpty() {
		return {
			type: 'invoice',
			client: {},
			issueDate: moment().format('YYYY-MM-DD'),
			issuePlace: settingStore.state.invoice.defaultIssuePlace || '',
			deliveryDate: moment().format('YYYY-MM-DD'),
			paymentDeadline: settingStore.state.invoice.defaultPaymentDeadline || 30,
			note: '',
			items: [
				{
					name: '',
					quantity: 1,
					price: 0.00
				}
			]
		};
	}

};



// WEBPACK FOOTER //
// ./src/stores/invoices.js